var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offer-group-item tw-flex tw-flex-col"},[_c('div',{staticClass:"tw-text-xs tw-uppercase tw-text-secondary-text tw-mb-1 tw-font-normal",domProps:{"textContent":_vm._s(_vm.title)}}),_c('div',{staticClass:"tw-font-medium tw-text-sm",class:{
      'tw-text-blue-500': _vm.active,
      'tw-text-secondary-lighten': !_vm.active
    }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }